var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Spin',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading),expression:"loading"}],attrs:{"fix":""}},[_c('FFIcon',{attrs:{"type":"circle-o-notch fa-spin fa-3x fa-fw"}}),_c('div',[_vm._v("Loading...")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }